import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./sortOptions.html";
import { WireStore } from '@oneappexchange/lwc-wired';
import { Size, Variant } from 'wds/button';
import { PopoverHorizontalOrientation, PopoverVerticalOrientation } from 'wds/popover';
import { WireI18n, i18nStore, selectSearchLabels } from '~/modules/stores/i18nStore';
import { DeviceType, selectDeviceType, viewportStore } from '~/modules/stores/viewportStore';
class SortOptions extends LightningElement {
  constructor(...args) {
    super(...args);
    this.displayTooltip = false;
    this.options = void 0;
    this.variant = Variant.Primary;
    this.size = Size.Default;
    this.labels = void 0;
    this.selectedOption = void 0;
    this.deviceType = void 0;
  }
  toggleTooltip() {
    if (this.displayTooltip === false) {
      this.showPopover();
    } else {
      this.closePopover();
    }
  }
  get sortButtonRef() {
    return this.template.querySelector('[data-id="sortButton"]');
  }
  get sortOptionsGroupRef() {
    return this.template.querySelector('[data-id="sortOptions"]');
  }
  get activeSortOptionRef() {
    const {
      value,
      shadowRoot
    } = this.sortOptionsGroupRef ?? {};
    return value ? shadowRoot?.querySelector(`input#${value}`) : undefined;
  }
  renderedCallback() {
    if (this.displayTooltip) {
      this.activeSortOptionRef?.focus();
    }
  }
  closePopover() {
    this.displayTooltip = false;
    this.sortButtonRef?.focus();
  }
  showPopover() {
    this.displayTooltip = true;
  }
  get selectedSortLabel() {
    return this.options.find(option => option.value === this.selectedOption)?.label || '';
  }
  get isMobilePhone() {
    return this.deviceType === DeviceType.PHONE;
  }
  get sortButtonLabel() {
    const {
      i18n
    } = i18nStore.getState();
    if (this.isMobilePhone) {
      return i18n.search.sort.button({
        criteria: ''
      });
    }
    return i18n.search.sort.button({
      criteria: this.selectedSortLabel
    });
  }
  get popoverOrientation() {
    const popoverOrientation = {
      vertical: PopoverVerticalOrientation.BOTTOM,
      horizontal: PopoverHorizontalOrientation.CENTER
    };
    return popoverOrientation;
  }
  handleTooltipKeyboardEvent(event) {
    switch (event.key) {
      case 'Escape':
      case 'Enter':
        // We want to shift focus back to the sort button
        event.preventDefault();
        this.closePopover();
        break;
      case 'Tab':
        // We want to let the focus move to the non-sort
        // element and close the popover
        this.displayTooltip = false;
        break;
      default:
        break;
    }
  }
  handleSortSelectionChange(event) {
    const {
      value,
      clicked
    } = event.detail;

    // hide dropdown if change was triggered by mouse click
    if (clicked) {
      this.closePopover();
    }
    this.dispatchEvent(new CustomEvent('sortselectionchange', {
      detail: {
        value,
        clicked
      }
    }));
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(SortOptions, {
  publicProps: {
    options: {
      config: 0
    },
    variant: {
      config: 0
    },
    size: {
      config: 0
    },
    selectedOption: {
      config: 0
    }
  },
  wire: {
    labels: {
      adapter: WireI18n,
      dynamic: [],
      config: function ($cmp) {
        return {
          selector: selectSearchLabels
        };
      }
    },
    deviceType: {
      adapter: WireStore,
      dynamic: [],
      config: function ($cmp) {
        return {
          store: viewportStore,
          selector: selectDeviceType
        };
      }
    }
  },
  fields: ["displayTooltip"]
});
const __lwc_component_class_internal = _registerComponent(SortOptions, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;